<template>
    <div class="contentBg">
        <div class="contentCenter">
           <img src="../../../public/logo.png" style="width: 100px;height: 80px;left:0px"/>
                医疗废物处置物联监控系统
        </div>
        <div class="bg">
            <div class="main" >
                <div style="height: 40px; ">
                    <a-form-item>
                        <strong v-if="display" style="color: red;line-height: 30px">账号或密码不能为空！！！</strong>
                    </a-form-item>
                </div>
                <div >
                    <a-form
                            class="user-layout-login"
                            :form="form"
                    >
                        <a-form-item>
                            <a-input
                                    size="large"
                                    type="text"
                                    placeholder="请输入账号"
                                    v-model="form.account"
                            >
                                <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                            </a-input>
                        </a-form-item>
                        <a-form-item>
                            <a-input-password
                                    size="large"
                                    placeholder="请输入密码"
                                    v-model="form.pass"
                            >
                                <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                            </a-input-password>
                        </a-form-item>

                        <a-form-item style="margin-top:24px">
                            <a-button
                                    size="large"
                                    type="primary"
                                    htmlType="submit"
                                    class="login-button"
                                    :loading="loginBtn"
                                    :disabled="loginBtn"
                                    @click="userLogin"
                            >确定
                            </a-button>
                        </a-form-item>
                    </a-form>
                </div>
            </div>
        </div>
        <div class="contentButtom">
            X公网安备XXXXXXXXXXXXXXX号 互联网新闻信息服务许可 ©2020
        </div>
    </div>

</template>

<script>
    import {login, setInfo} from './ApiLogin'

    export default {
        data() {
            return {
                isLoginError: false,
                form: {account: '', pass: ''},
                loginBtn: false,
                user: {},
                message: '',
                display: false
            }
        },
        methods: {
            userLogin() {
                if (!this.form.account || !this.form.pass) {
                    this.display = true
                } else {
                    login(this.form).then(res => {
                        setInfo(res.data);
                        // buildQualificationAlarm({});
                        this.$router.push({name: 'home'})
                    }).catch(error => {
                        console.log(error)
                    })
                }
            }
        }
    }
</script>

<style lang="less" scoped>
    .user-layout-login {
        label {
            font-size: 14px;
        }

        .getCaptcha {
            display: block;
            width: 100%;
            height: 40px;
        }

        .forge-password {
            font-size: 14px;
        }

        button.login-button {
            padding: 0 15px;
            font-size: 16px;
            height: 40px;
            width: 100%;
        }

        .user-login-other {
            text-align: left;
            margin-top: 24px;
            line-height: 22px;

            .item-icon {
                font-size: 24px;
                color: rgba(0, 0, 0, 0.2);
                margin-left: 16px;
                vertical-align: middle;
                cursor: pointer;
                transition: color 0.3s;

                &:hover {
                    color: #1890ff;
                }
            }

            .register {
                float: right;
            }
        }

    }

    .main {
        width: 300px;
        height: 220px;
        position: absolute;
        right: 15%;
        top: 55%;
        margin: -140px 0 0 -150px;
        padding: 0px 10px 0px 10px ;
        background-color: rgba(220,220,220,0.5);
        border-radius: 10px;
    }
    .contentBg{
        width: 100%;
        height: 100%;
    }
    .contentCenter{
        width: 100%;
        height: 100px;
        text-align: left;
        padding: 10px;
        font-size: 35px;
        color: forestgreen;
    }
    .contentButtom{
        width: 100%;
        height: 25px;
        text-align: center;
        padding: 10px;
        font-size: 20px;
        color: black;
    }
    .bg {
        width: 100%;
        height: 85%;
        background-image: url("../../../public/bg.jpg");
        background-size: 100% 100%;
    }
</style>
